const axios = require('axios')

export default {

  queryFinnexAPI: async function ( path, data, _headers ) {
    try {
        // const apiUrl = 'https://api.botboom.ru/finex/api';
        const apiUrl = 'https://finex.botboom.ru/finex/api';
        /*
        const apiUrl = 'https://api.maker-gpt.pro'
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjMwNDcxMDM2NSIsImlhdCI6MTczMzkzMzk3Mn0.aMY-NFN-xdCSyAgxmtrvqmiKwwRduN4eQ-_7xA4vZWg'
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          ..._headers
        }
        const _reply = await axios.post(`${apiUrl}${path}`, data, { headers })
        if (!_reply.data) throw new Error('api error')
        return _reply.data

        const formData = {
            currentStep: 'step0',
            steps: 19,
            step0: {
              debt: data.step0?.debt || 50000,
              fermer: data.step0?.fermer || 'Нет',
              businessman: data.step0?.businessman || 'Нет',
              stepNumber: 0,
              stepName: 'Начало',
              nextStep: () => 'step1',
              prevStep: () => '',
            },
            step1: {
              surname: '',
              name: '',
              middlename: '',
              birthDate: '',
              passpSerie: '',
              passpNumber: '',
              passpIssued: '',
              passpDate: '',
              passpCode: '',
              regionOfRegistration: '',
              registrationAddress: '',
              liveAddress: '',
              inn: '',
              ogrnip: '',
              snils: '',
              phoneNumber: '',
              email: '',
              stepName: 'Шаг 1: ФИО и адрес',
              stepNumber: 1,
              nextStep: () => 'step2',
              prevStep: () => 'step0',
            },
            step2: {
              realEstate: 'Не владею',
              realEstateData: [],
              realEstateType: '',
              movableProperty: 'Не владею',
              movablePropertyData: [],
              movablePropertyType: '',
              banksAccounts: 'Не имею',
              banksAccountsData: [],
              bussiness: 'Не имею',
              bussinessData: [],
              stock: 'Не владею',
              stocksData: [],
              money: 'Не владею',
              moneyData: [],
              stepName: 'Шаг 2: Собственность',
              stepNumber: 2,
              nextStep: () => 'step3',
              prevStep: () => 'step1',
            },
            step3: {
              transactions: 'Не совершал',
              transactionsData: [],
              stepName: 'Шаг 3: ПРОДАЖА ИМУЩЕСТВА',
              stepNumber: 3,
              nextStep: () => 'step4',
              prevStep: () => 'step2',
            },
            step4: {
              marriage: 'Не состою',
              partner: '',
              marriageData: [],
              spouseProperty: 'Не имеет',
              spousePropertyData: [],
              dissolution: 'Не расторгал',
              agreement: 'Нет',
              childs: 'Не имею',
              childsData: [],
              stepName: 'Шаг 4: СЕМЕЙНОЕ ПОЛОЖЕНИЕ',
              stepNumber: 4,
              nextStep: () => 'step5',
              prevStep: () => 'step3',
            },
            step5: {
              status: "",
              job: "",
              post: "",
              dosc: "",
              sum: "",
              date: "",
              stepName: 'Шаг 5: ТРУДОУСТРОЙСТВО',
              stepNumber: 5,
              nextStep: () => 'step6',
              prevStep: () => 'step4',
            },
            step6 :{
              lender1a: 'Нет',
              lenderMoneyData: [],
              lenderMoneyDataPayments: [],
              lender1b: 'Нет',
              lenderNoMoneyData: [],
              lender2a: 'Нет',
              lenderMoneyDataIP: [],
              lenderMoneyDataPaymentsIP: [],
              lender2b: 'Нет',
              lender2bData: [],
              lender3a: 'Нет',
              lender3aData: [],
              lender3aDataPayments: [],
              lender3b: 'Нет',
              lender3bData: [],
              lender4a: 'Нет',
              lender4aData: [],
              lender4aDataPayments: [],
              lender4b: 'Нет',
              lender4bData: [],
              stepName: 'Шаг 6: СВЕДЕНИЯ О КРЕДИТОРАХ И ДОЛЖНИКАХ',
              stepNumber: 6,
              nextStep: () => 'step7',
              prevStep: () => 'step5',
            },
            step7: {
              case: 'Не ведутся',
              caseData: [],
              stepName: 'Шаг 7: Судебные процессы',
              stepNumber: 7,
              nextStep: () => 'step8',
              prevStep: () => 'step6',
            },
            step8:{
              procedure: 'Не ведутся',
              procedureData: [],
              stepName: 'Шаг 8: Исполнительные производства',
              stepNumber: 8,
              nextStep: () => 'step9',
              prevStep: () => 'step7',
            },
            step9: {
              selectedSROName: '',
              stepName: 'Шаг 9: Выбор СРО',
              stepNumber: 9,
              nextStep: () => 'step10',
              prevStep: () => 'step8',
            },
            step10: {
              payment: 'Средства внесены',
              amountToManager: 0,
              stepName: 'Шаг 10: Внесение ДС на счет суда',
              stepNumber: 10,
              nextStep: () => 'step11',
              prevStep: () => 'step9',
            },
            step11 : {
              docs: [],
              stepName: 'Шаг 11: Список необходимых документов',
              stepNumber: 11,
              nextStep: () => 'step12',
              prevStep: () => 'step10',
            },
            step12 :{
              stepName: 'Шаг 12: Итоговый документ',
              stepNumber: 11,
              nextStep: () => '',
              prevStep: () => 'step11',
            },
          }
        */
        console.log(`[queryFinnexAPI] ${apiUrl}${path}`, data)
          const _reply = await axios.post(`${apiUrl}${path}`, data)
        if (!_reply.data) throw new Error('api error')
        return _reply.data
      } catch (err) {
        console.log(err.message || 'ошибка апи')
        return { err: true, message: err.message || 'ошибка апи' }
      }
  },

  queryDaData: async function (path, data) {
    try {
        const apiUrl = 'http://suggestions.dadata.ru'
        const token = '56ce462b066d997d206502af2d4691873c36b24c'
        const headers = {
          Authorization: `Token ${token}`,
          Accept: "application/json",
          'Content-Type': 'application/json'
        }
        path = '/suggestions/api/4_1/rs/suggest/address'
        const _reply = await axios.post(`${apiUrl}${path}`, data, { headers })
        if (!_reply.data) throw new Error('api error')
        return _reply.data
      } catch (err) {
        console.log(err.message || 'ошибка апи')
        return { err: true, message: err.message || 'ошибка апи' }
      }
  },

  searchSRO: async function (text) {
    const sroList = [
      {
        id: '1',
        name: '"Ассоциация ""Сибирская гильдия антикризисных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=9347be10-d52f-4aa6-aabe-33f72fc5c5ce',
        managers: '240',
        innogrn: 'ИНН: 8601019434 ОГРН: 1028600516735',
        address: '628011, Ханты-Мансийский автономный округ - Югра, г. Ханты-Мансийск, ул. Промышленная, д. 2, оф. 2',
        contact: 'тел. +7-499-240-69-75, e-mail: npsgau@npsgau.ru',
        region: "Уральский федеральный округ",
        area: "Ханты-Мансийский автономный округ"
      },
      {
        id: '2',
        name: '"АССОЦИАЦИЯ АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ ""АРСЕНАЛ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=a8aa64c8-c7a1-48b9-b6eb-50993d7fd13b',
        managers: '148',
        innogrn: 'ИНН	5406240676 ОГРН	1025402478980',
        address: '644122, Омская область, г. Омск, ул. 5 Армии, д. 4, офис 1',
        contact: 'Телефон/Факс	(3812) 21-10-12, 21-10-13, Адрес электронной почты	omsmsoau@mail.ru'
      },
      {
        id: '3',
        name: '"Союз арбитражных управляющих ""Созидание"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=b62316a3-db58-4635-8978-3f5fd9332eaa',
        managers: '222',
        innogrn: 'ИНН	7703363900 ОГРН	1027703026130',
        address: '119019, г. Москва, Нащокинский переулок, д. 12, строение 1, каб. 4',
        contact: 'Телефон/Факс	(499) 404-20-04, (926) 904-30-93, Адрес электронной почты	info@srosozidanie.ru'
      },
      {
        id: '4',
        name: '"ААУ ""ГАРАНТИЯ"" - Ассоциация арбитражных управляющих ""ГАРАНТИЯ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=16e69e04-33bd-46fc-9f97-19d628338726',
        managers: '148',
        innogrn: 'ИНН	7727278019 ОГРН	1087799004193',
        address: '115088, г. Москва, ул. 1-я Дубровская, д. 13а, стр. 1, комн. 20',
        contact: 'Телефон/Факс	+7 499 348 20 88, Адрес электронной почты	info@crogarantia.ru'
      },
      {
        id: '5',
        name: '"ААУ ""Содружество"" - Ассоциация Арбитражных Управляющих ""Содружество"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=b782ea03-6502-4b0f-b819-35df5b2e288a',
        managers: '184',
        innogrn: 'ИНН	7801351420 ОГРН	1137800008477',
        address: '192012, город Санкт-Петербург, улица Запорожская, дом 27, корпус 2, литер А, пом 3С. Старое 199004, г. Санкт-Петербург, 4-я линия В.О., дом 51, помещение 8Н',
        contact: 'Телефон/Факс	(812) 372-58-54, Адрес электронной почты	sod_au@mail.ru'
      },
      {
        id: '6',
        name: '"ААУ ""ЦФОП АПК"" - Ассоциация арбитражных управляющих ""Центр финансового оздоровления предприятий агропромышленного комплекса"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=72499a1b-120d-4e2e-b595-2a1b9f4ae70d',
        managers: '460',
        innogrn: 'ИНН	7707030411 ОГРН	1107799002057',
        address: '107996, г. Москва, ул. Б. Дмитровка, д. 32, стр. 1',
        contact: 'Телефон/Факс	8(495)668-09-90, 8(495) 668-09-91, Адрес электронной почты	partnerapk@partnerapk.ru'
      },
      {
        id: '7',
        name: '"Ассоциация профессиональных арбитражных управляющих ""Гарант"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=09b5650f-7a54-4f10-8b09-a14b6bb6fb7d',
        managers: '111',
        innogrn: 'ИНН	7730309884 ОГРН	1237700565332',
        address: '121059, г. Москва, вн. тер. г. муниципальный округ Дорогомилово, наб. Бережковская, д. 16, к. 2',
        contact: 'Телефон/Факс	+7 (985) 587-00-00, Адрес электронной почты	info@garant-arbitr.ru'
      },
      {
        id: '8',
        name: '"Ассоциация ""ДМСО"" - Ассоциация ""Дальневосточная межрегиональная саморегулируемая организация профессиональных арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=703725b4-bb9b-4310-8e31-15950ee1cb6f',
        managers: '229',
        innogrn: 'ИНН	2721099166 ОГРН	1032700295099',
        address: '680020, г. Хабаровск, пер. Доступный, 13, офис 6',
        contact: 'Телефон/Факс	8-909-825-41-00, тел./факс 8(4212)32-55-96, Адрес электронной почты	npdmso@yandex.ru'
      },
      {
        id: '9',
        name: '"Ассоциация ""КМ СРО АУ ""Единство"" - Ассоциация ""Краснодарская межрегиональная саморегулируемая организация арбитражных управляющих ""Единство"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=17667bd6-4765-49b1-b5c0-46667aa8d709',
        managers: '107',
        innogrn: 'ИНН	2309090437 ОГРН	1042304980794',
        address: '350007, Краснодарский край, гор. Краснодар, ул. Кубанская Набережная, д. 1/0',
        contact: 'Телефон/Факс	+7(861)992-65-75 +7(861)992-65-74, Адрес электронной почты	sro_edinstvo@mail.ru'
      },
      {
        id: '10',
        name: '"Ассоциация ""Межрегиональная саморегулируемая организация арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=ec545e2a-8ef3-46bd-806f-b7d238677af0',
        managers: '145',
        innogrn: 'ИНН	6167065084 ОГРН	1026104143218',
        address: '344011, г. Ростов-на-Дону, пер. Гвардейский, 7',
        contact: 'Телефон/Факс	(8632) 67-55-04, / (8632) 01-73-61, Адрес электронной почты	amsro@amsro.ru'
      },
      {
        id: '11',
        name: '"АССОЦИАЦИЯ ""МЕЖРЕГИОНАЛЬНАЯ САМОРЕГУЛИРУЕМАЯ ОРГАНИЗАЦИЯ ПРОФЕССИОНАЛЬНЫХ АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=f8cfca94-8400-4604-bba2-10f553568b8d',
        managers: '246',
        innogrn: 'ИНН	7705494552 ОГРН	1037705027249',
        address: '109240, 77, МОСКВА, КОТЕЛЬНИЧЕСКАЯ, 17',
        contact: 'Телефон/Факс	(495) 935-85-00, (495) 935-87-00, Адрес электронной почты	npmsopau@npmsopau.ru'
      },
      {
        id: '12',
        name: '"Ассоциация ""Межрегиональная Северо-Кавказская саморегулируемая организация профессиональных арбитражных управляющих ""Содружество"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=14c10fd2-a331-48da-9b45-a29657add96d',
        managers: '118',
        innogrn: 'ИНН	2635064804 ОГРН	1022601953296',
        address: '355000, г. Ставрополь, проспект Кулакова, 9"б"',
        contact: 'Телефон/Факс	(8652) 56-03-84, 56-03-85, Адрес электронной почты	msk_sro@mail.ru'
      },
      {
        id: '13',
        name: '"Ассоциация ""Национальная организация арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=8783e162-0fe7-40a7-ba63-9c31aafa9999',
        managers: '206',
        innogrn: 'ИНН	7710480611 ОГРН	1137799006840',
        address: '105062, г. Москва, Подсосенский пер., д. 30, стр. 3',
        contact: 'Телефон/Факс	+7 (495) 280-37-78, Адрес электронной почты	info@sroarbitr.ru'
      },
      {
        id: '0017 (исключена из реестра)',
        name: '"Ассоциация ""ПСОПАУ"" - Ассоциация ""Поволжская саморегулируемая организация профессиональных арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=73b86e0b-68e6-4675-8f1c-58cb74cbafb5',
        managers: '0'
      },
      {
        id: '14',
        name: '"Ассоциация ""Региональная саморегулируемая организация профессиональных арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=3b991dc0-a847-4c8b-8037-425ff8894544',
        managers: '202',
        innogrn: 'ИНН	7701317591 ОГРН	1027701018730',
        address: '119121, г. Москва, 2-й Неопалимовский переулок, д. 7, п. 1',
        contact: 'Телефон/Факс	8-499-348-28-99, Адрес электронной почты	info@rsopau.ru'
      },
      {
        id: '15',
        name: '"Ассоциация ""Саморегулируемая организация арбитражных управляющих ""Лига"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=c15686d7-a351-451b-a8f5-914e798e5bf6',
        managers: '107',
        innogrn: 'ИНН	5836140708 ОГРН	1045803007326',
        address: '440026, Пензенская область, Пенза, Володарского, 9',
        contact: 'Телефон/Факс	(8412)660818,562225 т/ф, 563317, Адрес электронной почты	2_liga.ru@list.ru'
      },
      {
        id: '16',
        name: '"Ассоциация ""Саморегулируемая организация арбитражных управляющих ""Меркурий"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=15239b1d-d859-4464-8bdf-d1966d2e2456',
        managers: '399',
        innogrn: 'ИНН	7710458616 ОГРН	1037710023108',
        address: '	125047, Российская Федерация, г. Москва, ул. 4-я Тверская-Ямская, д. 2/11, стр. 2',
        contact: 'Телефон/Факс	т. (495)748-04-15, ф. 8 (495)215-09-97, Адрес электронной почты	office@soautpprf.ru'
      },
      {
        id: '17',
        name: '"Ассоциация ""Саморегулируемая организация арбитражных управляющих ""Южный Урал"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=02bc6199-5ee4-4a61-82a0-e15cf95c5a3e',
        managers: '120',
        innogrn: 'ИНН	7452033727 ОГРН	1027443766019',
        address: '454020, г. Челябинск, ул. Энтузиастов, д. 23',
        contact: 'Телефон/Факс	(351) 225-27-90, Адрес электронной почты	info_sro@mail.ru'
      },
      {
        id: '18',
        name: '"АССОЦИАЦИЯ ""САМОРЕГУЛИРУЕМАЯ ОРГАНИЗАЦИЯ АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ ЦЕНТРАЛЬНОГО ФЕДЕРАЛЬНОГО ОКРУГА"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=7533e69f-928e-4b40-b9c3-f35929fdd729',
        managers: '378',
        innogrn: 'ИНН	7705431418 ОГРН	1027700542209',
        address: '115191, 77, МОСКВА, ГАМСОНОВСКИЙ, Д. 2, ЭТАЖ 1 КОМ. 85',
        contact: 'Телефон/Факс	(495) 287-48-60, 287-48-61, Адрес электронной почты	info@paucfo.ru'
      },
      {
        id: '0026 (исключена из реестра)',
        name: '"Ассоциация ""СРО АУ ""Доверие"" - Ассоциация ""Саморегулируемая организация арбитражных управляющих ""Доверие"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=fce29e16-2e1e-4f4e-a202-b7ea916e583f',
        managers: '0'
      },
      {
        id: '0038 (исключена из реестра)',
        name: '"Ассоциация ""СРО АУ ""Стабильность"" - Ассоциация ""Саморегулируемая организация арбитражных управляющих ""Стабильность"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=224285f1-bfbc-4722-9160-0d0a06c165f9',
        managers: '0'
      },
      {
        id: '001-1 (исключена из реестра)',
        name: 'Ассоциация «Первая Саморегулируемая Организация Арбитражных Управляющих зарегистрированная в едином государственном реестре саморегулируемых организаций арбитражных управляющих»',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=900b83f0-b731-4a9c-9d34-5b16b4d05f7a',
        managers: '0'
      },
      {
        id: '0035 (исключена из реестра)',
        name: '"АССОЦИАЦИЯ АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ ""ОРИОН"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=55e63b93-3937-4875-b4c4-69a95403d3a5',
        managers: '0'
      },
      {
        id: '19',
        name: '"Ассоциация арбитражных управляющих ""СИБИРСКИЙ ЦЕНТР ЭКСПЕРТОВ АНТИКРИЗИСНОГО УПРАВЛЕНИЯ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=0b16b54f-3daf-4fac-85f5-6a0d71823146',
        managers: '266',
        innogrn: 'ИНН	5406245522 ОГРН	1035402470036',
        address: '630091, г. Новосибирск, ул. Писарева, д. 4',
        contact: 'Телефон/Факс	т. (383) 383-00-05, ф. (383) 383-00-05, Адрес электронной почты	novosibsro@novosibsro.ru'
      },
      {
        id: '20',
        name: '"Ассоциация арбитражных управляющих ""СИРИУС"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=4466ae86-222e-4c84-bb12-c824aeec0481',
        managers: '129',
        innogrn: 'ИНН	5043069006 ОГРН	1205000015615',
        address: '	142280, Московская область, г. Протвино, Кременковское шоссе, д. 2, офис 104/2',
        contact: 'Телефон/Факс	+7 (495) 909 24 52, Адрес электронной почты	info@sro-sirius.ru'
      },
      {
        id: '21',
        name: '"Ассоциация арбитражных управляющих ""Современные банкротные решения"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=9888c547-d6c9-49de-bcde-914e2fdc88f0',
        managers: '132',
        innogrn: 'ИНН	8604071792 ОГРН	1218600007955',
        address: '628301, Ханты-Мансийский автономный округ - Югра, г. Нефтеюганск, мкр. 2, д. 22, кв. 29',
        contact: 'Телефон/Факс	+7 (982) 924 00 44; +7 (901) 156 51 51, Адрес электронной почты	info@sro-sobr.ru'
      },
      {
        id: '22',
        name: '"Ассоциация арбитражных управляющих ""Солидарность"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=a4c66139-adbe-49d0-a64f-5667bf9bb34a',
        managers: '213',
        innogrn: 'ИНН	8604999157 ОГРН	1138600001737',
        address: '628305, Ханты-Мансийский автономный округ - Югра, г. Нефтеюганск, ул. Жилая, Промышленная зона Пионерная, строение 13, оф. 205',
        contact: 'Телефон/Факс	(992)- 362- 62-25, (922) 047-42-74, Адрес электронной почты	np-solidarnost@mail.ru'
      },
      {
        id: '23',
        name: '"Ассоциация арбитражных управляющих ""Структура"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=c30bf6ac-e742-4ec4-b191-ad3139ebd537',
        managers: '101',
        innogrn: 'ИНН	0278980666 ОГРН	1230200045206',
        address: '450078, Республика Башкортостан, г. Уфа, ул. Революционная, д. 221, помещ. 30',
        contact: 'Телефон/Факс	+7 (347) 285-55-09, Адрес электронной почты	info@srostruktura.ru'
      },
      {
        id: '24',
        name: 'Ассоциация арбитражных управляющих «ЕВРАЗИЯ»',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=9f6e9b6f-d239-42f3-af2d-0711ebf175e4',
        managers: '115',
        innogrn: 'ИНН	5837071895 ОГРН	1185835002968',
        address: '115191, г. Москва, ул. Городская, д. 8, оф. 38',
        contact: 'Телефон/Факс	8 (499) 450-39-77, Адрес электронной почты	sroevrasia@gmail.com'
      },
      {
        id: '25',
        name: '"Ассоциация арбитражных управляющих саморегулируемая организация ""Центральное агентство арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=08422e0b-4cc3-4c28-9e89-9ca52edb16d0',
        managers: '412',
        innogrn: 'ИНН	7731024000 ОГРН	1107799028523',
        address: '119017, г. Москва 1-й Казачий переулок, д. 8, стр. 1',
        contact: 'Телефон/Факс	8-499-238-28-93, Адрес электронной почты	office@npca.ru'
      },
      {
        id: '26',
        name: '"Ассоциация ВАУ ""Достояние"" Ассоциация Ведущих Арбитражных Управляющих ""Достояние"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=ba0513b4-6666-4574-bc85-80c5a9d8fa1e',
        managers: '200',
        innogrn: 'ИНН	7811290230 ОГРН	1117800013000',
        address: '196191, г. Санкт-Петербург, пл. Конституции, д. 7, оф. 315',
        contact: 'Телефон/Факс	8-812-490-74-18, Адрес электронной почты	info@sro-dostoyanie.ru'
      },
      {
        id: '27',
        name: 'Ассоциация Евросибирская саморегулируемая организация арбитражных управляющих',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=d1365fb9-66d9-4b08-8c67-ecf1ac02c35e',
        managers: '313',
        innogrn: 'ИНН	0274107073 ОГРН	1050204056319',
        address: '115114, гор. Москва, Шлюзовая набережная, д. 8, стр. 1, оф. 301',
        contact: 'Телефон/Факс	(499) 110-27-77, Адрес электронной почты	eurosibsro@gmail.com'
      },
      {
        id: '28',
        name: '"Ассоциация МСОПАУ - Ассоциация ""Московская саморегулируемая организация профессиональных арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=0edcc9eb-569b-44cc-9073-7969d5b83bff',
        managers: '205',
        innogrn: 'ИНН	7701321710 ОГРН	1027701024878',
        address: '101100, г. Москва, Лубянский проезд, д. 5, стр. 1',
        contact: 'Телефон/Факс	+7 (495) 363-38-84, Адрес электронной почты	info@msopau.ru'
      },
      {
        id: '29',
        name: '"Ассоциация МСРО ""Содействие"" - Ассоциация ""Межрегиональная саморегулируемая организация арбитражных управляющих ""Содействие"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=7fbc79a1-7104-4d55-adc4-6983e49675a8',
        managers: '249',
        innogrn: 'ИНН	5752030226 ОГРН	1025700780071',
        address: '	302004, г. Орел, ул. 3-я Курская, 15, помещение 6, офис 14.',
        contact: 'Телефон/Факс	(4862) 54-39-89 - факс, 54-03-48, 54-03-49, Адрес электронной почты	mail@msro.ru'
      },
      {
        id: '30',
        name: '"Ассоциация саморегулируемая организация ""Объединение арбитражных управляющих ""Лидер"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=a8e13118-0336-4e8a-b7f4-67616d4cf5cb',
        managers: '101',
        innogrn: 'ИНН	7714402935 ОГРН	1147799010380',
        address: '129626, г. Москва, Проспект Мира, д. 104, эт/пом/ком 6/I/5',
        contact: 'Телефон/Факс	8(495)909-82-86, 8(985)042-11-19, Адрес электронной почты	nplidersro@mail.ru'
      },
      {
        id: '31',
        name: '"Ассоциация саморегулируемая организация арбитражных управляющих ""Межрегиональный центр экспертов и профессиональных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=c5c0c59c-c1f7-4e15-b262-85b57d387600',
        managers: '173',
        innogrn: 'ИНН	7743069037 ОГРН	1027743016652',
        address: '119048, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ ХАМОВНИКИ, УЛ ТРУБЕЦКАЯ, Д. 12, ПОМЕЩ. 17/1',
        contact: 'Телефон/Факс	8-985-777-13-69, Адрес электронной почты	info@mcpu.ru'
      },
      {
        id: '32',
        name: '"Ассоциация саморегулируемая организация арбитражных управляющих ""Эгида"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=89574035-2a8e-4e3f-8c00-91fe2f7216c4',
        managers: '149',
        innogrn: 'ИНН	5836141204 ОГРН	1105800001526',
        address: '170100, г. Тверь, б-р Радищева, д. 11, оф. 17',
        contact: 'Телефон/Факс	8 (916)999-91-01, Адрес электронной почты	info@egida-sro.ru'
      },
      {
        id: '33',
        name: '"Крымский союз профессиональных арбитражных управляющих ""ЭКСПЕРТ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=162b3c7f-586b-4916-ad3c-66a0525acb6f',
        managers: '118',
        innogrn: 'ИНН	9102024960 ОГРН	1149102040185',
        address: '298600, Республика Крым, г. Ялта, ул. Садовая, д. 4, литера "З", кв. 5',
        contact: 'Телефон/Факс	+7(978)9229-555, Адрес электронной почты	souz-expert@mail.ru'
      },
      {
        id: '34',
        name: 'Национальный Союз профессионалов антикризисного управления',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=dda84cd8-1f3b-421a-89c7-a44109843bc8',
        managers: '0',
        innogrn: 'ИНН	7707378583 ОГРН	1177700002325',
        address: '	121069, гор. Москва, ул. Поварская, д. 10, стр. 1, эт/пом 4/26',
        contact: 'Телефон/Факс	+7 985 547-79-99, Адрес электронной почты	info@nspau.ru'
      },
      {
        id: '007-1 (исключена из реестра)',
        name: '"Некоммерческое партнерство ""Саморегулируемая организация арбитражных управляющих ""РСНЭ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=531f30d5-d68e-4158-ba7e-5e42eb2d8d29',
        managers: '0'
      },
      {
        id: '35',
        name: '"Некоммерческое партнерство Саморегулируемая организация арбитражных управляющих ""РАЗВИТИЕ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=7532fbc5-789c-4b3f-bca2-01984c701cdb',
        managers: '117',
        innogrn: 'ИНН	7703392442 ОГРН	1077799003435',
        address: '117105, г. Москва, Варшавское ш., д. 1, стр. 1-2, комн. 36',
        contact: 'Телефон/Факс	(499) 400-58-87, Адрес электронной почты	info@razvitiesro.ru'
      },
      {
        id: '0020 (исключена из реестра)',
        name: '"НП ""Арбитражное управление в ЮФО"" - ""Некоммерческое партнерство ""Арбитражное управление в Южном федеральном округе"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=e15530f2-d3f6-4fbb-b9c3-1ac39bcb72bd',
        managers: '0'
      },
      {
        id: '0005 (исключена из реестра)',
        name: '"НП ""НГАУ"" - Некоммерческое партнерство ""Национальная гильдия арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=3941720d-d631-4e07-947f-d64180b0c562',
        managers: '0'
      },
      {
        id: '0016 (исключена из реестра)',
        name: '"НП ""СРО АУ ""МИЦ"" - Некоммерческое партнерство ""Саморегулируемая организация арбитражных управляющих ""Межрегиональный инвестиционный центр"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=3534e4ab-412d-45dc-9e69-2a56effbdde4',
        managers: '0'
      },
      {
        id: '0025 (исключена из реестра)',
        name: '"НП ""СРО АУ ""Объединение"" - Некоммерческое партнерство ""Саморегулируемая организация арбитражных управляющих ""Объединение"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=ccd46205-60f6-4c13-99c9-771afa8831fc',
        managers: '0'
      },
      {
        id: '0013 (исключена из реестра)',
        name: '"НП ""ТОСО"" - Некоммерческое партнерство ""Тихоокеанская саморегулируемая организация арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=5d73ce49-fe9b-4345-bf41-0f59470b446b',
        managers: '0'
      },
      {
        id: '36',
        name: '"НПС СОПАУ ""Альянс управляющих"" - Некоммерческое Партнёрство - Союз ""Межрегиональная саморегулируемая организация профессиональных арбитражных управляющих ""Альянс управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=511c2b3b-71cb-4204-8539-6aff92f4e639',
        managers: '357',
        innogrn: 'ИНН	2312102570 ОГРН	1032307154285',
        address: '350015, г. Краснодар, ул. Северная, д. 309',
        contact: 'Телефон/Факс	т/ф (861) 253-51-51, 259-29-99, факс 259-24-44, Адрес электронной почты	alliance_au@bk.ru'
      },
      {
        id: '0028 (исключена из реестра)',
        name: 'РССОАУ - Российский Союз Саморегулируемых Организаций Арбитражных Управляющих',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=c5bca0d6-d767-4d3e-a864-1ba02f5a7c96',
        managers: '0'
      },
      {
        id: '37',
        name: '"Саморегулируемая межрегиональная общественная организация ""Ассоциация антикризисных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=b963bf25-6543-4192-951a-068ced7ec5ba',
        managers: '514',
        innogrn: 'ИНН	6315944042 ОГРН	1026300003751',
        address: '443072, г. Самара, Московское шоссе, 18-й км',
        contact: 'Телефон/Факс	(846) т/ф 278-81-23, 278-81-24, Адрес электронной почты	samro@bk.ru'
      },
      {
        id: '38',
        name: '"Саморегулируемая организация ""Ассоциация арбитражных управляющих ""Паритет"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=93ee006b-7aa8-4f84-b0db-b5c833703e35',
        managers: '147',
        innogrn: 'ИНН	7701325056 ОГРН	1037701009565',
        address: '141206, Московская область, г. Пушкино, ул. 2-я Домбровская, д. 25',
        contact: 'Телефон/Факс	(495) 788-39-38, Адрес электронной почты	paritet.moskva@mail.ru'
      },
      {
        id: '39',
        name: '"Саморегулируемая организация ""Союз менеджеров и арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=e7d06412-31d4-4c56-8b99-71803119a643',
        managers: '122',
        innogrn: 'ИНН	7709395841 ОГРН	1027709028160',
        address: '109029, г. Москва, ул. Нижегородская, д. 32, корп. 15',
        contact: 'Телефон/Факс	(495) 713-90-65, 713-90-66, Адрес электронной почты	sro_003@mail.ru'
      },
      {
        id: '40',
        name: '"САМОРЕГУЛИРУЕМАЯ ОРГАНИЗАЦИЯ СОЮЗ ""АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ ""ПРАВОСОЗНАНИЕ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=c62ed683-57e8-445a-a117-eedccfa700e1',
        managers: '109',
        innogrn: 'ИНН	5029998905 ОГРН	1145000002146',
        address: '420000, 16, ТАТАРСТАН, Елабужский, Елабуга, СТРОИТЕЛЕЙ, Д. 25 А, ОФИС 6',
        contact: 'Телефон/Факс	8-987-188-71-11, Адрес электронной почты	Pravosoznanie@bk.ru'
      },
      {
        id: '0001 (исключена из реестра)',
        name: '"Союз ""Кузбасская СОАУ"" - Союз ""Кузбасская саморегулируемая организация арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=07c50fac-2c09-4c3a-9ab2-82482ebf2540',
        managers: '0'
      },
      {
        id: '41',
        name: '"Союз ""МЦАУ"" - Союз ""Межрегиональный центр арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=9c41d59a-2c0b-4665-9e38-e25bca5b1f83',
        managers: '134',
        innogrn: 'ИНН	7604200693 ОГРН	1117600001419',
        address: '150040, г. Ярославль, ул. Некрасова, д. 39Б',
        contact: 'Телефон/Факс	4852-28-00-77, Адрес электронной почты	info@npmcau.ru'
      },
      {
        id: '42',
        name: '"СОЮЗ ""САМОРЕГУЛИРУЕМАЯ ОРГАНИЗАЦИЯ АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ СЕВЕРО-ЗАПАДА"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=58452ba5-1b70-4001-b4df-fa5df81f6c30',
        managers: '208',
        innogrn: 'ИНН	7825489593 ОГРН	1027809209471',
        address: '191015, 78, САНКТ-ПЕТЕРБУРГ, ШПАЛЕРНАЯ, ДОМ 51ЛИТЕР А, ПОМЕЩЕНИЕ 2-Н №436',
        contact: 'Телефон/Факс	(812) 576-70-07, 576-76-73, 576-77-31, Адрес электронной почты	mail@sroausz.ru'
      },
      {
        id: '43',
        name: '"Союз ""СОАУ ""Альянс"" - Союз ""Саморегулируемая организация арбитражных управляющих ""Альянс"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=45f81c60-881c-4fa0-93c5-6ea482e1e42a',
        managers: '171',
        innogrn: 'ИНН	5260111600 ОГРН	1025203032062',
        address: '603000, г. Нижний Новгород, ул. Ильинская, д. 69, к. 10',
        contact: 'Телефон/Факс	т/(831) 414-03-90, 414-03-91, Адрес электронной почты	schepetov_av@mail.ru'
      },
      {
        id: '44',
        name: '"Союз ""Уральская саморегулируемая организация арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=0a3b8382-19c7-4ba4-a96a-c42d532f3b64',
        managers: '141',
        innogrn: 'ИНН	6670019784 ОГРН	1026604954947',
        address: '620014, г. Екатеринбург, ул. Вайнера, 13, Литер Е',
        contact: 'Телефон/Факс	тел.:(343) 310-29-71, (343) 310-29-72, Адрес электронной почты	npursoau@mail.ru'
      },
      {
        id: '45',
        name: 'СОЮЗ «САМОРЕГУЛИРУЕМАЯ ОРГАНИЗАЦИЯ АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ «СТРАТЕГИЯ»',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=f63650ec-1eee-43d4-b2a4-cce377d671bf',
        managers: '211',
        innogrn: 'ИНН	3666101342 ОГРН	1023601559035',
        address: '121601, г. Москва, вн. тер. г. муниципальный округ Филевский парк, б-р Филевский, д. 40, помещ. 9Н',
        contact: 'Телефон/Факс	8(985)131-32-14, Адрес электронной почты	info@sro-strategy.ru'
      },
      {
        id: '46',
        name: '"Союз арбитражных управляющих ""Авангард"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=ab12fb24-df2b-469d-aedc-630323ce326b',
        managers: '184',
        innogrn: 'ИНН	7705479434 ОГРН	1027705031320',
        address: '101000,Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ БАСМАННЫЙ, Б-Р ПОКРОВСКИЙ, Д. 4/17, СТР. 1, ПОМЕЩ. IV, ПОМЕЩ. VII',
        contact: 'Телефон/Факс	8(495) 189-74-45, Адрес электронной почты	avangard@oau.ru'
      },
      {
        id: '47',
        name: '"СОЮЗ АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ ""ВОЗРОЖДЕНИЕ"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=1541c971-cbbc-47a6-bbc3-628c67b2da58',
        managers: '216',
        innogrn: 'ИНН	7718748282 ОГРН	1127799026486',
        address: '101000, г. Москва, б-р Покровский, д. 4/17, стр. 1 помещ. II',
        contact: 'Телефон/Факс	(495) 249-04-22, Адрес электронной почты	office@oaufenix.ru'
      },
      {
        id: '48',
        name: '"СОЮЗ АРБИТРАЖНЫХ УПРАВЛЯЮЩИХ ""КОНТИНЕНТ"" (САМОРЕГУЛИРУЕМАЯ ОРГАНИЗАЦИЯ)"',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=058979b5-14af-4e6b-bd01-e2c7eec7ddfc',
        managers: '177',
        innogrn: 'ИНН	7810274570 ОГРН	1027804888704',
        address: '196607, Г. САНКТ-ПЕТЕРБУРГ, ВН. ТЕР.Г. ГОРОД ПУШКИН, Г ПУШКИН, Б-Р АЛЕКСЕЯ ТОЛСТОГО, Д. 50, К. 1, ЛИТЕРА А, ПОМЕЩ. 9-Н, КОМ. 12',
        contact: 'Телефон/Факс	т/ф (812) 314-70-02, Адрес электронной почты	office@sro-continent.ru'
      },
      {
        id: '49',
        name: '"Союз арбитражных управляющих ""Национальный Центр Реструктуризации и Банкротства"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=10cd177e-e16b-44a0-b2b7-d6e162b6a835',
        managers: '186',
        innogrn: 'ИНН	7813175754 ОГРН	1027806876173',
        address: '123056, г. Москва, Вн. Тер. Муниципальный округ Пресненский, ул. Большая Грузинская, д. 61, стр. 2, помещ. 19/9',
        contact: 'Телефон/Факс	(812) 454-55-36, 454-55-37, Адрес электронной почты	info@ncrb-au.ru'
      },
      {
        id: '50',
        name: '"Союз арбитражных управляющих ""Саморегулируемая организация ""ДЕЛО"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=9101372b-cdd8-4207-b315-2a4abc7159cf',
        managers: '280',
        innogrn: 'ИНН	5010029544 ОГРН	1035002205919',
        address: '125284, г Москва, г. Москва, Хорошевское шоссе, 32А, оф.300, а/я 22',
        contact: 'Телефон/Факс	тел. (495) 988-76-62, Адрес электронной почты	info@sro-delo.ru'
      },
      {
        id: '51',
        name: '"Союз СРО ""ГАУ"" - Союз ""Саморегулируемая организация ""Гильдия арбитражных управляющих"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=d0e0c285-a284-4a75-9169-6203dfe264c8',
        managers: '461',
        innogrn: 'ИНН	1660062005 ОГРН	1021603626098',
        address: '420034, г. Казань, ул. Соловецких Юнг, д.7, оф. 1004',
        contact: 'Телефон/Факс	+7 (900) 322 22 52, Адрес электронной почты	info@gaurt.ru'
      },
      {
        id: '52',
        name: '"СРО ААУ ""Синергия"" - Саморегулируемая организация ассоциация арбитражных управляющих ""Синергия"""',
        link: 'https://old.bankrot.fedresurs.ru/SroCard.aspx?ID=54e53abf-7860-4e0f-9d2a-9653852b0451',
        managers: '151',
        innogrn: 'ИНН	2308980067 ОГРН	1112300002330',
        address: '350000, г. Краснодар, ул. Комсомольская, д. 45, оф. 11',
        contact: 'Телефон/Факс	8 800 777 77 84, Адрес электронной почты	srosynergy@mail.ru'
      }
    ].filter(el => el.id.indexOf('исключена') == -1)

    return sroList.filter(el => JSON.stringify(el).toLowerCase().indexOf(text) !== -1)
  },

  searchBank: async function (text) {
    const bankList = `
    "ПАО АКБ 1Банк"
"АКБ Абсолют Банк (ПАО)"
"ПАО АКБ АВАНГАРД"
"АО Банк Аверс"
"АО Авто Финанс Банк"
"АО Автоградбанк"
"ООО АвтоКредитБанк"
"ООО АТБ Банк"
"БАНК АГОРА ООО"
"ПАО АГРОИНКОМБАНК"
"АО КБ АГРОПРОМКРЕДИТ"
"(АО Банк Агророс)"
"ООО КБ Агросоюз"
"ООО КБ Адмиралтейский"
"Азиатско-Тихоокеанский Банк (АО)"
"Азия-Инвест Банк (АО)"
"РНКО АЗИЯПЭЙ ООО"
"ООО КБ АйМаниБанк"
"АйСиБиСи Банк (АО)"
"ПАО АК БАРС БАНК"
"ООО КБ АкадемРусБанк"
"ПАО АКИБАНК"
"ООО КБ Аксонбанк"
"АО АК Банк"
"АО Банк Акцепт"
"АКБ Акция ОАО"
"АБ Алданзолотобанк АО"
"ПАО Банк АЛЕКСАНДРОВСКИЙ"
"АО АКБ Алеф-Банк"
"АКБ Алмазэргиэнбанк АО"
"ООО КБ Алтайкапиталбанк"
"ООО АЛТЫНБАНК"
"ООО КБ Альба Альянс"
"КБ Альта-Банк (ЗАО)"
"НКО Альтернатива (ООО)"
"АО АЛЬФА-БАНК"
"РНКО АМАНАТ (ООО)"
"АМБ Банк (ПАО)"
"ООО Америкэн Экспресс Банк"
"ООО РНКО АМРА"
"ООО АМТ БАНК"
"АНКОР БАНК (АО)"
"КБ Анталбанк ООО"
"АКБ АПАБАНК (АО)"
"НКО ООО АРБ-ИНКАСС"
"ООО КБ АРЕСБАНК"
"АО комбанк Арзамас"
"АО Арксбанк"
"КБ Арсенал ООО"
"АБ АСПЕКТ (АО)"
"АО КБ Ассоциация"
"ОАО АФ Банк"
"БайкалБанк (ПАО)"
"КБ Байкалкредобанк (АО)"
"АО БАЛАКОВО-БАНК"
"ПАО АКБ Балтика"
"ПАО БАЛТИНВЕСТБАНК"
"Банк - Т (ОАО)"
"ПАО Банк Санкт-Петербург"
"АО Банк 131"
"АО БАНК БЕРЕЙТ"
"ООО КБ Банк БФТ"
"БАНК ГОРОД (АО)"
"АО Банк ДОМ.РФ"
"АО Банк БЖФ"
"ПАО Банк ЗЕНИТ"
"АО Банк Интеза"
"ООО КБЭР Банк Казани"
"ООО Банк БКФ"
"АО Банк Кредит Свисс (Москва)"
"ОАО БАНК МБФИ"
"МП Банк (ООО)"
"АКБ БНКВ (АО)"
"ООО Банк Оранжевый"
"АО БАНК ОРЕНБУРГ"
"ПАО Банк Премьер Кредит"
"АКБ БРР (ОАО)"
"ООО банк Раунд"
"Банк РМП (АО)"
"ООО Банк РСИ"
"ЗАО С банк"
"АО БАНК СГБ"
"АО Банк ФИНАМ"
"ООО БАНК ФИНИНВЕСТ"
"АО Банк ЧБРР"
"Банк24.ру (ОАО)"
"АО АКБ Банкирский Дом"
"ООО РНКО Банковская зона"
"ББР Банк (АО)"
"АО УКБ Белгородсоцбанк"
"АКБ Бенифит-банк (ЗАО)"
"КБ БДБ (ООО)"
"БСТ-БАНК АО"
"АО БКС Банк"
"ООО Бланк банк"
"АО БМ-Банк"
"ООО БМВ Банк"
"БНП ПАРИБА БАНК АО"
"Банк Богородский (ООО)"
"КБ БМБ (ООО)"
"АБ БПФ (ЗАО)"
"Братский АНКБ АО"
"АО КБ БТФ"
"ОАО Инвестбанк БЗЛ"
"АО Булгар банк"
"БУМ-БАНК, ООО"
"АО Комсоцбанк Бумеранг"
"КБ БФГ-Кредит (ООО)"
"ПАО БыстроБанк"
"АКБ БЭНК ОФ ЧАЙНА (АО)"
"ООО Вайлдберриз Банк"
"АО КБ ВАКОБАНК"
"ВЛБАНК (АО)"
"ПАО Банк ВВБ"
"КБ ВЕГА-БАНК (ООО)"
"АКБ ВЕК (АО)"
"АО Великие Луки банк"
"АО Банк Венец"
"ООО НКО Вестерн Юнион ДП Восток"
"ООО Вестинтербанк"
"АО КАБ Викинг"
"АО Витабанк"
"ООО Витас Банк"
"РНКО ВК Платёжные решения (ООО)"
"АО ВЛАДБИЗНЕСБАНК"
"ООО Владпромбанк"
"ООО Внешпромбанк"
"ООО КБ ВНЕШФИНБАНК"
"ОАО ВКБ"
"АО Вологдабанк"
"АО Банк Вологжанин"
"АО Банк Воронеж"
"АО ВостСибтранскомбанк"
"Банк ВПБ (АО)"
"Банк ВБРР (АО)"
"Банк ВТБ (ПАО)"
"АО ВУЗ-банк"
"ПАО Выборг-банк"
"Вэйбанк АО"
"Банк Вятич (ПАО)"
"КБ Гагаринский (АО)"
"АО АКБ ГАЗБАНК"
"Банк ГПБ (АО)"
"АО АКБ ГАЗСТРОЙБАНК"
"ООО КБ ГТ банк"
"АО Газэнергобанк"
"КБ Гарант-Инвест (АО)"
"АО ГЕНБАНК"
"КБ Геобанк (ООО)"
"ООО КБ Гефест"
"Банк Глобус (АО)"
"ООО Голдман Сакс Банк"
"АО ГОРБАНК"
"АО ГринКомБанк"
"АО Гринфилдбанк"
"АО ГУТА-БАНК"
"ООО Дагэнергобанк"
"АО Банк ДАЛЕНА"
"АО Дальневосточный банк"
"АО Датабанк"
"АО Денизбанк Москва"
"АКБ Держава ПАО"
"КБ Дж.П. Морган Банк Интернешнл (ООО)"
"ООО Джаст Банк"
"ИАБ Диг-Банк (ОАО)"
"Дил-банк (ООО)"
"КБ ДС-Банк (ООО)"
"ООО Дойче Банк"
"КБ Долинск (АО)"
"ООО КБ Донинвест"
"ПАО Донкомбанк"
"МКБ Дон-Тексбанк ООО"
"ПАО Донхлеббанк"
"ООО КБ ДОРИС БАНК"
"ООО Драйв Клик Банк"
"ООО КБ Дружба"
"РНКО ЕАРК (АО)"
"АО ЕАТПБанк"
"АО ЕвроАксис Банк"
"АО КИБ ЕВРОАЛЬЯНС"
"ПАО КБ ЕВРОКОММЕРЦ"
"Банк Еврокредит (ООО)"
"АКБ ЕИБ ЗАО"
"КБ ЕВРОСТАНДАРТ (ООО)"
"ПАО КБ ЕвроситиБанк"
"КБ ЕВРОТРАСТ (ЗАО)"
"АО АКБ ЕВРОФИНАНС МОСНАРБАНК"
"ООО РНКО Единая касса"
"КБ ЕДИНСТВЕННЫЙ (ООО)"
"ПАО Банк Екатерининский"
"АКБ ЕНИСЕЙ (ПАО)"
"АО АИКБ Енисейский объединенный банк"
"АО БАНК Ермак"
"ООО ЖИВАГО БАНК"
"ООО КБ Жилкредит"
"ОАО МКБ Замоскворецкий"
"ОАО Банк Западный"
"Банк Заречье (АО)"
"АО Заубер Банк"
"ООО ЗЕМКОМБАНК"
"ООО Земский банк"
"АО Зернобанк"
"ЗИРААТ БАНК (МОСКВА) (АО)"
"АО КБ Златкомбанк"
"АО КБ ИВАНОВО"
"ПАО ИДЕЯ Банк"
"АО ИК Банк"
"АИБ Имбанк (ОАО)"
"ООО Инбанк"
"АКБ Инвестбанк (ОАО)"
"КБ ИНВЕСТИЦИОННЫЙ СОЮЗ (ООО)"
"БАНК ИТБ (АО)"
"ИНВЕСТТОРГБАНК АО"
"ИНГ БАНК (ЕВРАЗИЯ) АО"
"АО Ингосстрах Банк"
"АКБ ИНКАРОБАНК (АО)"
"ООО КБ Инстройбанк"
"Интерактивный Банк (ООО)"
"КБ ИНТЕРКОММЕРЦ (ООО)"
"КБ Интеркредит (АО)"
"Банк ИПБ (АО)"
"АО КБ ИНТЕРПРОМБАНК"
"ПАО ИнтехБанк"
"АКБ ИнтрастБанк (ОАО)"
"РНКО ИНЭКО (ООО)"
"ЗАО ИпоТек Банк"
"АО КБ ИС Банк"
"НКО Истина (АО)"
"АО ИТ Банк"
"Банк ИТУРУП (ООО)"
"АО ИШБАНК"
"Банк Йошкар-Ола (ПАО)"
"ООО КБ Калуга"
"ООО КБ Камский горизонт"
"ООО Камкомбанк"
"КБ Канский ООО"
"АО АБ Капитал"
"АКБ Капиталбанк (ПАО)"
"АО Кемсоцинбанк"
"ООО КБ Кетовский"
"КИВИ Банк (АО)"
"АО Классик Эконом Банк"
"Банк Клиентский (АО)"
"АО КОММЕРЦБАНК (ЕВРАЗИЯ)"
"КБ КБР БАНК (ООО)"
"Коммерческий Индо Банк ООО"
"КБ КРК (ОАО)"
"АО Банк ККБ"
"АО АКБ Констанс-Банк"
"КБ Континенталь ООО"
"ПАО Контур.Банк"
"ООО КБ Конфидэнс Банк"
"АО КБ КОСМОС"
"ООО Костромаселькомбанк"
"АО КОШЕЛЕВ-БАНК"
"АО Кранбанк"
"Креди Агриколь КИБ АО"
"АО Кредит Европа Банк (Россия)"
"Банк КУБ (АО)"
"ООО КБ Кредит Экспресс"
"ОАО ККБ КРЕДИТБАНК"
"Банк Кредит-Москва (ПАО)"
"Банк Кремлевский ООО"
"КБ Крокус-Банк (ООО)"
"ООО Крона-Банк"
"АО Кросна-Банк"
"АКБ КРОССИНВЕСТБАНК (ОАО)"
"АКБ Крыловский (АО)"
"КБ Кубанский универсальный банк (ООО)"
"КБ Кубань Кредит ООО"
"АО Кубаньторгбанк"
"АКБ Кузбассхимбанк (ПАО)"
"АО Кузнецкбизнесбанк"
"ПАО Банк Кузнецкий"
"ООО БАНК КУРГАН"
"ООО КЭБ ЭйчЭнБи Банк"
"ЗАО КБ ЛАДА-КРЕДИТ"
"ООО КБ Лайтбанк"
"АКБ Ланта-Банк (АО)"
"Банк Левобережный (ПАО)"
"АКБ Легион (АО)"
"ООО ЛЕНОБЛБАНК"
"ОАО АКБ Лесбанк"
"КБ ЛОКО-Банк (АО)"
"НКО ЛЦК (АО)"
"РНКО Люминис (АО)"
"ПАО М2М Прайвет Банк"
"КБ Максима (ООО)"
"ОАО КБ Максимум"
"ОАО КБ МАСТ-Банк"
"Мастер-Банк (ОАО)"
"АКБ Мастер-Капитал (ОАО)"
"ООО МБ РУС Банк"
"Банк МБА-МОСКВА ООО"
"АО КБ МБР-банк"
"ООО КБ МВС Банк"
"ООО КБ Мегаполис"
"НКО МКС (ООО)"
"ЗАО МАБ"
"КБ Международный Банк Развития (АО)"
"Банк МБСП (АО)"
"ЗАО Международный Промышленный Банк"
"КБ МСБ (ООО)"
"АО АКБ МЕЖДУНАРОДНЫЙ ФИНАНСОВЫЙ КЛУБ"
"КБ МФБанк ООО"
"КБ МРБ (ООО)"
"ПАО Межтопэнергобанк"
"ООО КБ МЕЖТРАСТБАНК"
"ПАО АКБ Металлинвестбанк"
"ООО РНКО Металлург"
"ПАО МЕТКОМБАНК"
"АО МЕТРОБАНК"
"КБ Метрополь ООО"
"АО Мидзухо Банк (Москва)"
"КБ МИКО-БАНК ООО"
"ООО КБ МИЛБАНК"
"Миллениум Банк (ЗАО)"
"АО МБ Банк"
"АО Мираф-Банк"
"АКБ МИРЪ (АО)"
"КБ МКБ (АО)"
"ООО НКО МОБИ.Деньги"
"ООО НКО Мобильная карта"
"АО КБ Модульбанк"
"НКО МОНЕТА (ООО)"
"ООО КБ Монолит"
"МОРСКОЙ БАНК (АО)"
"ОАО КБ МВКБ"
"АО БАНК МОСКВА-СИТИ"
"АО МОСКОМБАНК"
"ПАО МОСКОВСКИЙ КРЕДИТНЫЙ БАНК"
"АО МОСОБЛБАНК"
"КБ Москоммерцбанк (АО)"
"ЗАО М БАНК"
"АКБ Мосуралбанк (АО)"
"АО МС Банк Рус"
"БАНК МСКБ (АО)"
"АО МСП Банк"
"АО МТИ Банк"
"ПАО МТС-Банк"
"Муниципальный Камчатпрофитбанк (АО)"
"ООО НКО Мурманский расчетный центр"
"Банк Навигатор (ОАО)"
"Банк Нальчик ООО"
"АО БАНК НБТ"
"АО НДБанк"
"ОАО Банк Народный кредит"
"Натиксис Банк АО"
"ОАО НББ"
"АО БАНК НБС"
"Нацинвестпромбанк (АО)"
"НКО НКЦ (АО)"
"АКБ НРБанк (АО)"
"АО Банк Национальный стандарт"
"НАЦКОРПБАНК (АО)"
"ПАО НБД-Банк"
"ПАО Невский банк"
"БАНК НЕЙВА ООО"
"КБ НЕФТЯНОЙ АЛЬЯНС (ПАО)"
"АКБ НЗБанк, ОАО"
"АО КБ НИБ"
"АО НВКбанк"
"ПАО НИКО-БАНК"
"АО НК Банк"
"ООО КБ НКБ"
"ПАО АКБ Новация"
"АО АКБ НОВИКОМБАНК"
"ПАО УКБ Новобанк"
"ООО НОВОКИБ"
АКБ НМБ ОАО
"ООО КБ Новопокровский"
"КБ Новый век (ООО)"
"КБ НМБ ООО"
"АО РНКО НОДА"
АО НОКССБАНК
"АКБ НООСФЕРА (АО)"
"ПАО Норвик Банк"
"НОТА-Банк (ПАО)"
НКО АО НРД
"АО НС Банк"
"АО НСТ-БАНК"
"ООО КБ Нэклис-Банк"
"АКИБ ОБРАЗОВАНИЕ (АО)"
"АКБ ОБПИ (ПАО)"
"АО Банк Объединенный капитал"
"ПАО О.К. Банк"
"ООО КБ ОГНИ МОСКВЫ"
"ООО ОЗОН Банк"
"ООО КБ ОПМ-Банк"
"АО ОРБАНК"
"АО ОТП Банк"
"ПАО ОФК Банк"
ПВ-Банк (ЗАО)
"Банк Первомайский (ПАО)"
"АО ПЕРВОУРАЛЬСКБАНК"
"АО Первый Дортрансбанк"
"АО Первый Инвестиционный Банк"
"ООО Первый Клиентский Банк"
"ОАО ПРБ"
"КБ Первый Экспресс (ОАО)"
"АКБ ПЕРЕСВЕТ (ПАО)"
Банк Пермь (АО)
"НКО Перспектива (ООО)"
НКО АО ПРЦ
"АО Банк ПСКБ"
ООО ПИР Банк
"НКО Платежи и Расчеты (АО)"
"АО РНКО ПЛАТЕЖНЫЕ ТЕХНОЛОГИИ"
"ООО РНКО Платежный конструктор"
"ОАО Банк ПСБ"
"РНКО Платежный Центр (ООО)"
"ООО КБ ПЛАТИНА"
"АО КБ Пойдём!"
"АО Почта Банк"
"АО АКИБ Почтобанк"
"Банк Прайм Финанс (АО)"
"ООО Примтеркомбанк"
"ПАО АКБ Приморье"
"ПАО СКБ Приморья Примсоцбанк"
"АО КБ Приобье"
Прио-Внешторгбанк (ПАО)
"КБ ПРИСКО КАПИТАЛ БАНК, АО"
"ОАО АКБ Пробизнесбанк"
"ООО ПроКоммерцБанк"
"АКБ ПРОМИНВЕСТБАНК (ПАО)"
"ООО Промрегионбанк"
"ЗАО Промсбербанк"
"ООО Промсельхозбанк"
Банк ПТБ (ООО)
"ПАО КБ ПФС-БАНК"
"АО Промэнергобанк"
"АО ПроБанк"
"АКБ Проинвестбанк (АО)"
"ПАО Банк ПСБ"
"ООО КБ Пульс Столицы"
"ОАО АБ ПУШКИНО"
ООО ПЧРБ Банк
"ООО НКО ПэйПал РУ"
"ПАО НКБ РАДИОТЕХБАНК"
"ООО КБ Развитие"
"АО Банк Развитие-Столица"
"АО Райффайзенбанк"
"ООО НКО Расчетные Решения"
"КБ РБА (ООО)"
НКО ЦК РДК (АО)
"АО РЕАЛИСТ БАНК"
"ПАО АКБ РБР"
"ООО КБ РБС"
"АО БАНК РКБ"
"РЕГНУМ БАНК (ООО)"
"ООО КБ Ренессанс"
"КБ Ренессанс Кредит (ООО)"
"Банк РЕСО Кредит (АО)"
"Республиканский Кредитный Альянс ООО"
"ООО РИКБ Ринвестбанк"
"РНКО Р-ИНКАС (ООО)"
"НКО РКЦ ДВ (АО)"
"ООО КБ РОСАВТОБАНК"
"ПАО АРКБ Росбизнесбанк"
"ПАО РосДорБанк"
РОСКОМСНАББАНК (ПАО)
"АО Россельхозбанк"
"АО РФК-банк"
"ОАО БАНК РОССИЙСКИЙ КРЕДИТ"
РНКБ Банк (ПАО)
"КБ РОСПРОМБАНК (ООО)"
"МКИБ РОССИТА-БАНК ООО"
"АО АБ РОССИЯ"
"ООО КБ РостФинанс"
АО РОСЭКСИМБАНК
"КБ РЭБ (АО)"
"АО Роял Кредит Банк"
"АО БАНК РСКБ"
"АО КБ РУБанк"
"АО КБ РУБЛЕВ"
"КБ Рублевский ООО"
"АО РУНА-БАНК"
"АО РУНЭТБАНК"
"АО Рускобанк"
"АО КБ РУСНАРБАНК"
"ООО РУСБС"
"РИАБАНК (АО)"
"КБ Русский ипотечный банк (ООО)"
"АО РМБ БАНК"
"ПАО КБ РусьРегионБанк"
БАНК РСБ 24 (АО)
"АО Банк Русский Стандарт"
"АО РУССТРОЙБАНК"
"КБ РТБК (ООО)"
"АКБ Русский Трастовый Банк (АО)"
"ПАО АКБ РФА"
"Русьуниверсалбанк (ООО)"
"АО КБ САММИТ БАНК"
Санкт-Петербургский банк инвестиций (АО)
"ООО Банк Саратов"
"Коммерческий банк СДБ (ООО)"
ПАО Сбербанк
"АО Свой Банк"
"СДМ-Банк (ПАО)"
"АО КБ Северный Кредит"
"Северный Народный Банк (АО)"
"АКБ СВА (АО)"
"СеверСтройБанк АО"
"ПАО КБ Сельмашбанк"
"Банк СЕРВИС РЕЗЕРВ (АО)"
Банк СБРР (ООО)
"ОАО СИБНЕФТЕБАНК"
"СИБСОЦБАНК ООО"
"Банк СИБЭС (АО)"
"ОАО ГБ Симбирск"
АО Банк Синара
"ООО КБ СИНКО-БАНК"
"АО Сити Инвест Банк"
"АО КБ Ситибанк"
"АКБ СЛАВИЯ (АО)"
"АО НКБ СЛАВЯНБАНК"
"АКБ СЛАВЯНСКИЙ БАНК (ЗАО)"
"АО СМАРТБАНК"
"ООО СМЛТ Банк"
"Банк Смолевич (ПАО)"
"ОАО Смоленский Банк"
"Банк Снежинский АО"
"Соверен Банк (АО)"
"АО Банк Советский"
"ПАО Совкомбанк"
"ОАО Банк СОДРУЖЕСТВО"
"АО КБ Соколовский"
"АО Солид Банк"
"Банк Солидарность АО"
"АО КБ Солидарность"
"БАНК СОФРИНО (ЗАО)"
"СОЦИУМ-БАНК (ООО)"
"ООО КБ СОЮЗНЫЙ"
"ПАО СПБ Банк"
"НКО-ЦК СПБ Клиринг (АО)"
"ООО СПЕЦСТРОЙБАНК"
"АКБ Спурт (ПАО)"
"КБ Спутник (ПАО)"
ПАО Ставропольпромстройбанк
"АО СтарБанк"
"АО АКБ Стелла-Банк"
"ООО КБ Столичный Кредит"
"АКБ СТРАТЕГИЯ (ПАО)"
"ОАО КБ Стройкредит"
"КБ СТРОЙЛЕСБАНК (ООО)"
СБ Банк (ООО)
"АО СМБСР Банк"
"АО БАНК СНГБ"
"АО СЭБ Банк"
"Банк Таатта АО"
Таврический Банк (АО)
"АО Таганрогбанк"
"ООО НКО Тайдон"
"ПАО Тайм Банк"
"ООО КБ Тальменка-банк"
"АО Банк ТКПБ"
"ООО ТАТАГРОПРОМБАНК"
"АО ТАТСОЦБАНК"
"ПАО Татфондбанк"
Таурус Банк (АО)
"АО ТБанк"
"ООО НКО Твои платежи"
"ПАО МАБ Темпбанк"
"АКБ ТЕНДЕР-БАНК (АО)"
"АО Тимер Банк"
"АО Тойота Банк"
"АО Тольяттихимбанк"
"ПАО Томскпромстройбанк"
"АО БАНК ТГБ"
"АО Банк Торжок"
"ООО Банк Точка"
ТКБ БАНК ПАО
"КБ Транснациональный банк (ООО)"
"ООО КБ Транспортный"
"АКБ Трансстройбанк (АО)"
"Банк ТРАСТ (ПАО)"
"АО ТРОЙКА-Д БАНК"
"АО ТУСАРБАНК"
"АО ТЭМБР-БАНК"
"ЗАО ТЮМЕНЬАГРОПРОМБАНК"
"АО Углеметбанк"
"ООО УИК-БАНК"
"УМ-Банк ООО"
"КБ Унифин АО"
"ООО Унифондбанк"
"ЗАО КБ УРАЛЛИГА"
"АО УРАЛПРОМБАНК"
"ПАО БАНК УРАЛСИБ"
"ПАО Уралтрансбанк"
"ООО КБ Уралфинанс"
"ПАО КБ УБРиР"
"ООО УралКапиталБанк"
"ОАО УРАЛЬСКИЙ ТРАСТОВЫЙ БАНК"
"АО КБ Урал ФД"
"АО Ури Банк"
"Банк Уссури (АО)"
"АО ФИА-БАНК"
"ООО КБ Финансовый капитал"
"КБ Финансовый стандарт (ООО)"
"ФИНАРС Банк (АО)"
"АКБ ФИНПРОМБАНК (ПАО)"
"АО Банк Финсервис"
ПАО ФИНСТАР БАНК
"ООО Фольксваген Банк РУС"
"АКБ ФОРА-БАНК (АО)"
"АО ФОРУС Банк"
"АКБ Форштадт (АО)"
"ООО Хакасский муниципальный банк"
"ПАО Комбанк Химик"
"АО КБ Хлынов"
"КБ Холдинг-Кредит ООО"
"НКО Центр расчетов (АО)"
"ООО КБ Центрально-Европейский Банк"
"ПАО КБ Центр-инвест"
Центркомбанк ООО
"АО АКБ ЦентроКредит"
"Банк ЦЕРИХ (ЗАО)"
"ООО Цифра банк"
"ООО РНКО ЦИФРОВЫЕ РЕШЕНИЯ"
ЦМРБанк (ООО)
"ООО Чайна Констракшн Банк"
"ООО Чайнасельхозбанк"
"ПАО ЧЕЛИНДБАНК"
"ПАО ЧЕЛЯБИНВЕСТБАНК"
"АКБ ЧУВАШКРЕДИТПРОМБАНК ПАО"
"ООО КБ ЭКО-ИНВЕСТ"
"АО Экономбанк"
Банк Экономический Союз (АО)
"ОАО АКБ ЭКОПРОМБАНК"
ЭКСИ-Банк (АО)
"АО Эксперт Банк"
"АО Экспобанк"
"ОАО АКБ ЭКСПРЕСС"
"КБ Экспресс-кредит (АО)"
"ООО КБ Эл банк"
"ООО НКО ЭЛЕКСИР"
"АО НКО ЭЛЕКСНЕТ"
"НКО ЭПС (ООО)"
"ООО банк Элита"
"ООО НКО ЭЛПЛАТ"
"АО АКБ ЭЛЬБИН"
"АО Эм-Ю-Эф-Джи Банк (Евразия)"
"АКБ Энергобанк (АО)"
"ПАО Энергомашбанк"
"КБ ЭНЕРГОТРАНСБАНК (АО)"
"ООО РНКО ЭР Финанс"
"ООО КБ ЭРГОБАНК"
Эс-Би-Ай Банк ООО
"ООО ЭСИДБАНК"
"ООО Ю Би Эс Банк"
ЮГ-Инвестбанк (ПАО)
"ПАО БАНК ЮГРА"
"ООО НКО ЮМани"
"ООО ЮМК банк"
"ОАО ЮНИКОРБАНК"
АО ЮниКредит Банк
"АО КБ ЮНИСТРИМ"
"РНКО Юнона Финанс (ООО)"
"АО Яндекс Банк"
"ИКБР ЯРИНТЕРБАНК (ООО)"
    `
    return bankList.split('\n').filter(el => el.toLowerCase().indexOf(text) !== -1)
  },

  attachments: function () {
    const defaultAttachments = [
            {
              step: 6,
              name: 'Уведомление о вручении или иные документы, подтверждающие направление другим лицам, участвующим в деле (конкурсным кредиторам, уполномоченным органам), копий заявления и приложенных к нему документов, которые у других лиц, участвующих в деле, отсутствуют.',
              description: 'Уведомление о вручении или иные документы, подтверждающие направление другим лицам, участвующим в деле (конкурсным кредиторам, уполномоченным органам), копий заявления и приложенных к нему документов, которые у других лиц, участвующих в деле, отсутствуют.',
              necessary: false,
              attached: false
            },
            {
              step: 1,
              name: 'Доверенность или иные документы, подтверждающие полномочия на подписание заявления (в случае, если от имени гражданина заявление подписывает его представитель)',
              description: 'Доверенность или иные документы, подтверждающие полномочия на подписание заявления (в случае, если от имени гражданина заявление подписывает его представитель)',
              necessary: false,
              attached: false
            },
            {
              step: 10,
              name: 'Документ, подтверждающий внесение денежных средств на выплату вознаграждения финансовому управляющему в депозит арбитражного суда',
              description: 'Документ, подтверждающий внесение денежных средств на выплату вознаграждения финансовому управляющему в депозит арбитражного суда',
              necessary: true,
              conditions: { step: 'step10', var: 'payment', value: 'Средства внесены' },
              attached: false
            },
            {
              step: 6,
              name: 'Документы, подтверждающие наличие задолженности, а также неспособность должника удовлетворить требования кредиторов в полном объеме, основание возникновения задолженности (копии кредитных договоров, договоров займа).',
              description: 'Документы, подтверждающие наличие задолженности, а также неспособность должника удовлетворить требования кредиторов в полном объеме, основание возникновения задолженности (копии кредитных договоров, договоров займа).',
              necessary: true,
              attached: false
            },
            {
              step: 1,
              name: 'Справка, подтверждающая наличие или отсутствие у гражданина статуса индивидуального предпринимателя на основании выписки из единого государственного реестра индивидуальных предпринимателей либо иного подтверждающего указанные сведения документа (документы должны быть получены не ранее чем за пять рабочих дней до даты подачи в арбитражный суд гражданином заявления о признании его банкротом)',
              description: 'Справка, подтверждающая наличие или отсутствие у гражданина статуса индивидуального предпринимателя на основании выписки из единого государственного реестра индивидуальных предпринимателей либо иного подтверждающего указанные сведения документа (документы должны быть получены не ранее чем за пять рабочих дней до даты подачи в арбитражный суд гражданином заявления о признании его банкротом)',
              necessary: true,
              attached: false
            },
            {
              step: 2,
              name: 'Опись имущества гражданина с указанием места нахождения или хранения имущества, в том числе имущества, являющегося предметом залога, с указанием наименования или фамилии, имени и отчества залогодержателя (форма представления указанных списков утверждена приказом Минэкономразвития от 05.08.2015 № 530)',
              description: '',
              necessary: false,
              attached: false
            },
            {
              step: 2,
              name: 'Копии документов, подтверждающих право собственности гражданина на имущество (справки, сведения (выписки) из государственных и регистрирующих органов), и документов, удостоверяющих исключительные права на результаты интеллектуальной деятельности гражданина (при наличии)',
              description: '',
              necessary: false,
              attached: false
            },
            {
              step: 3,
              name: 'Копии документов о совершавшихся гражданином в течение трех лет до даты подачи заявления сделках с недвижимым имуществом, ценными бумагами, долями в уставном капитале, транспортными средствами и сделках на сумму свыше трехсот тысяч рублей (при наличии)',
              description: '',
              necessary: false,
              attached: false
            },
            {
              step: 2,
              name: 'Выписка из реестра акционеров (участников) юридического лица, акционером (участником) которого является гражданин (при наличии)',
              description: '',
              necessary: false,
              attached: false
            },
            {
              step: 5,
              name: 'Сведения о полученных физическим лицом доходах и об удержанных суммах налога за трехлетний период, предшествующий дате подачи заявления о признании гражданина банкротом (справка 2-НДФЛ)',
              description: '',
              necessary: false,
              attached: false
            },
            {
              step: 2,
              name: 'Выданная банком (-ами) справки о наличии вкладов (депозитов) в банке и (или) об остатках денежных средств на счетах, во вкладах (депозитах), выписки по операциям на счетах, по вкладам (депозитам) граждан в банке за трехлетний период, предшествующий дате подачи заявления о признании гражданина банкротом, справки об остатках электронных денежных средств и о переводах электронных денежных средств за трехлетний период, предшествующий дате подачи заявления о признании гражданина банкротом (при наличии)',
              description: '',
              necessary: true,
              attached: false
            },
            {
              step: 1,
              name: 'Копия страхового свидетельства обязательного пенсионного страхования (СНИЛС)',
              description: '',
              necessary: true,
              attached: false
            },
            {
              step: 1,
              name: 'Сведения о состоянии индивидуального лицевого счета застрахованного лица',
              description: '',
              necessary: true,
              attached: false
            },
            {
              step: 5,
              name: 'Справка о признании гражданина безработным, выданная государственной службой занятости населения (в случае принятия указанного решения)',
              description: '',
              necessary: false,
              attached: false
            },
            {
              step: 1,
              name: 'Копия свидетельства о постановке на учет в налоговом органе (ИНН, при наличии)',
              description: '',
              necessary: true,
              attached: false
            },
            {
              step: 4,
              name: 'Копия свидетельства о заключении брака (при наличии заключенного и не расторгнутого на дату подачи заявления брака)',
              description: '',
              necessary: true,
              conditions: { step: 'step4', var: 'marriage', value: 'Состою' },
              attached: false
            },
            {
              step: 4,
              name: 'Копия свидетельства о расторжении брака (при наличии)',
              description: '',
              necessary: true,
              conditions: { step: 'step4', var: 'dissolution', value: 'Да' },
              attached: false
            },
            {
              step: 4,
              name: 'Копия брачного договора (при наличии)',
              description: '',
              necessary: true,
              conditions: { step: 'step4', var: 'marriageAggrDate', value: '' },
              attached: false
            },
            {
              step: 4,
              name: 'Копия соглашения или судебного акта о разделе общего имущества супругов, соответственно заключенного и принятого в течение трех лет до даты подачи заявления (при наличии)',
              description: '',
              necessary: true,
              attached: false
            },
            {
              step: 4,
              name: 'Копия свидетельства о рождении ребенка (если гражданин является его родителем, усыновителем или опекуном)',
              description: '',
              necessary: true,
              conditions: { step: 'step4', var: 'childs', value: 'Имею' },
              attached: false
            }
          ]
    return defaultAttachments
  },

  html2docx: async function ({ html, options, phone}) {
    const docData = await axios.post('https://finex.botboom.ru/finex/api/html2docx', { phone, html },{
      responseType: 'blob' // Указываем тип ответа blob для получения бинарных данных
    })
    return docData.data
  }

}